import IllustrationList from "../../../../src/components/IllustrationList";
import IllustrationTypesSnippet from "snippets/illustration-types.mdx";
import IllustrationNonvisualSnippet from "snippets/illustration-nonvisual.mdx";
import * as React from 'react';
export default {
  IllustrationList,
  IllustrationTypesSnippet,
  IllustrationNonvisualSnippet,
  React
};